<template>
    <Map class="animated fadeIn" type="Trợ giúp" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
